<ng-template #content_b2b_owner let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.b2b && elementIds">
        <div class="side_popup_header">
            <span>{{localService.languageContent.b2b.owners}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" style="padding: 10px;"
            [ngStyle]="{'max-height' : localService.sideBarBodyHeight + 'px'}">
            <div *ngFor="let item of items" class="banner">
                <div class="row styled_row">
                    <div class="col-12">
                        <div [ngClass]="localService.getLanguageCode(item.v4)">
                            {{item.v3}}
                        </div>
                        <div>
                            <span>{{item.v2}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-8">
                    <input autocomplete="off" type="number" class="number"
                        (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.contact_nbr}}"
                        [(ngModel)]="contactNumber" style="width:100%;text-align: left;"
                        placeholder="*{{localService.languageContent.b2b.contact_nbr}}"
                        title="{{localService.languageContent.b2b.contact_nbr}}"
                        [ngClass]="contactNumber ? 'en' : ''" (keydown.enter)="onAction(1)"/>
                </div>
                <div class="col-4" style="text-align: right;">
                    <button id="{{elementIds.add}}" type="button" [disabled]="!contactNumber" class="btn btn-primary"
                        (click)="onAction(1)">
                        {{localService.languageContent.common.add}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>